import { render, staticRenderFns } from "./DxWeatherHumidityGrid.vue?vue&type=template&id=f4cb9004&"
import script from "./DxWeatherHumidityGrid.vue?vue&type=script&lang=js&"
export * from "./DxWeatherHumidityGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports